import gql from 'graphql-tag';

export const UPDATE_SURVEY_FILTER = gql`
  mutation updateSurveyFilter($filter: SurveyFilterInput!, $orderBy: [String], $pagination: SurveyPaginationInput) {
    updateSurveyFilter(filter: $filter, orderBy: $orderBy, pagination: $pagination) @client
  }
`;
